import defaultFromPOQuery from 'graphql/queries/supplier/MatchPurchaseOrderDefaultFromPO.graphql';
import PurchaseInvoice from './PurchaseInvoice';

const MatchPurchaseOrders = {
  ...PurchaseInvoice,
  formTitle: 'Match Purchase Orders',
  formUrl: '/Suppliers/MatchPurchaseOrders/Details/',
  default: defaultFromPOQuery,
  screenReference: 'SUPPLIER_INVOICES',
};

export default MatchPurchaseOrders;
